import classnames from 'classnames';
import React, { useState } from 'react';
import { object } from 'prop-types';
import { Menu } from '@material-ui/icons';
import { Hidden, Drawer, Fab } from '@material-ui/core';

import DashboardForms from './DashboardForms';
import styles from './styles.scss';

export const DashboardDrawer = ({ container }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(true);
  const handleMobileDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawerToggle = () => {
    setOpen(!open);
  };
  return (
    <React.Fragment>
      <Hidden mdUp implementation='css'>
        <Fab
          className={styles.menuButtonMobile}
          color="primary"
          onClick={handleMobileDrawerToggle}
          size="small"
        >
          <Menu color="inherit" />
        </Fab>
        <Drawer
        anchor='right'
          classes={{
            modal: styles.drawerModal,
          }}
          container={container}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          onClose={handleMobileDrawerToggle}
          open={mobileOpen}
          variant='temporary'
        >
          <DashboardForms onDrawerToggle={handleMobileDrawerToggle} />
        </Drawer>
      </Hidden>
      <Hidden smDown implementation='css'>
        <div className={classnames(styles.drawerWrapper, !open && styles.drawerWrapperClosed)}>
          <Fab
            className={styles.menuButton}
            color="primary"
            onClick={handleDrawerToggle}
            size="small"
          >
            <Menu color="inherit" />
          </Fab>
          <Drawer
            anchor='right'
            classes={{
              docked: styles.drawerDocked,
            }}
            open={open}
            variant='persistent'
          >
            <DashboardForms isMobile onDrawerToggle={handleDrawerToggle} />
          </Drawer>
        </div>
      </Hidden>
    </React.Fragment>
  );
};

DashboardDrawer.propTypes = {
  container: object,
};

export default DashboardDrawer;
